import React from 'react';
import { GiPaperClip } from 'react-icons/gi';

const FilePreview = ({ fileUrl, fileName, className = '' }) => {
  const getFileExtension = url => {
    return url.split('.').pop().toLowerCase();
  };

  const isImage = url => {
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
    return imageExtensions.includes(getFileExtension(url));
  };

  const isPDF = url => {
    return getFileExtension(url) === 'pdf';
  };

  if (isImage(fileUrl)) {
    return (
      <div className={`mt-2 max-w-xs ${className}`}>
        <img
          src={fileUrl}
          alt={fileName || 'Attached image'}
          className="rounded-lg max-w-full h-auto cursor-pointer hover:opacity-90 transition-opacity"
          onClick={() => window.open(fileUrl, '_blank')}
        />
      </div>
    );
  }

  if (isPDF(fileUrl)) {
    return (
      <div
        className={`mt-2 p-3 bg-white bg-opacity-50 rounded-lg border border-gray-300 max-w-xs ${className}`}>
        <div className="flex items-center">
          <div className="w-8 h-8 bg-red-500 rounded flex items-center justify-center mr-3">
            <span className="text-white text-xs font-bold">PDF</span>
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-xs font-medium text-gray-900 truncate">
              {fileName || 'PDF Document'}
            </p>
            <button
              onClick={() => window.open(fileUrl, '_blank')}
              className="text-xs text-blue-600 hover:text-blue-800 underline">
              View PDF
            </button>
          </div>
        </div>
      </div>
    );
  }

  // For other file types
  return (
    <div
      className={`mt-2 p-3 bg-white bg-opacity-50 rounded-lg border border-gray-300 max-w-xs ${className}`}>
      <div className="flex items-center">
        <div className="w-8 h-8 bg-gray-500 rounded flex items-center justify-center mr-3">
          <GiPaperClip className="text-white text-sm" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-xs font-medium text-gray-900 truncate">
            {fileName || 'Attached File'}
          </p>
          <button
            onClick={() => window.open(fileUrl, '_blank')}
            className="text-xs text-blue-600 hover:text-blue-800 underline">
            Download
          </button>
        </div>
      </div>
    </div>
  );
};

export default FilePreview;
